import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './standard_dialog.less'
import Dialog from 'components/common/dialog'
import { Link } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'

class StandardDialog extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    okButtonTitle: PropTypes.string,
    closeButtonTitle: PropTypes.string,
    onOk: PropTypes.func,
    onClose: PropTypes.func,
    onQuit: PropTypes.func,
    isDelete: PropTypes.bool,
  }

  render() {
    let propsToTransfer = { ...this.props }
    delete propsToTransfer.styles
    return (
      <Dialog {...propsToTransfer} onClose={this.props.onClose}>
        <div styleName="title">{this.props.title}</div>
        <div styleName="subtitle">{this.props.subtitle}</div>
        {this.props.okButtonTitle &&
          !this.props.isDelete && (
            <button
              className="vx_btn vx_btn-block"
              styleName="ok-button"
              onClick={this.props.onOk}
            >
              {this.props.okButtonTitle}
            </button>
          )}
        {this.props.okButtonTitle &&
          this.props.isDelete && (
            <Link
              to={glimpseRoute('edit', 'delete/review')}
              data-nemo="deleteButton"
              className="vx_btn vx_btn-block"
              styleName="delete-button"
              onClick={this.props.onOk}
            >
              {this.props.okButtonTitle}
            </Link>
          )}
        <button
          className="vx_btn vx_btn-block vx_btn-secondary"
          styleName="close-button"
          onClick={this.props.onQuit ? this.props.onQuit : this.props.onClose}
        >
          {this.props.closeButtonTitle}
        </button>
      </Dialog>
    )
  }
}

export default cssModules(StandardDialog, styles)
